module.exports = __webpack_public_path__ + "img/1505858681.d2c30c91.jpg";